// extracted by mini-css-extract-plugin
export default {"searchIcon":"AddressInput_searchIcon__sm+sW"};